/*
 * @Author: your name
 * @Date: 2021-10-26 15:12:40
 * @LastEditTime: 2021-12-14 17:08:46
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xl-driver-index-web\src\main.js
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/styles/index.less';
import init from '@/common/init';
import initSa from '@/common/init-sa';
import { env, isProd } from '@/config/host';
import probes from '@xl/sec-sign-sdk';
import performanceReport from '@xl/performance-report';
import sensors from 'sa-sdk-javascript';
import '@/plugins/vant';

const envStr = isProd ? '' : `-${env}`;
const allowList = [
  `driver${envStr}.xiaolachuxing.com`,
  `dic-driver${envStr}.xiaolachuxing.com`,
  `orderhall${envStr}.xiaolachuxing.com`,
  `dpc-driver${envStr}.xiaolachuxing.com`,
  `dcs-driver${envStr}.xiaolachuxing.com`,
  `dappweb${envStr}.xiaolachuxing.com`,
];
// 接口安全签名
probes.init({
  allowList,
});

Vue.config.productionTip = false;

// 初始化 store 数据，app 通用参数初始化
store.dispatch('initAppStore');

Vue.filter('price', function(value: number) {
  return value / 100;
});

// 通用初始化
init(Vue);
// 神策初始化
initSa(Vue);

// 性能上报
performanceReport((params) => {
  sensors.track(`$_index_${params.action.toLowerCase()}`, params);
});

// 解决ios返回页面不刷新问题
if ('onpagehide' in window) {
  window.addEventListener('pageshow', function() {
    store.commit('setAppVal', { pageShow: true });
  });
  window.addEventListener('pagehide', function() {
    store.commit('setAppVal', { pageShow: false });
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
